import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutMovement, WorkoutMovementWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateWorkoutMovement(): UseMutationResult<
  AxiosResponse<WorkoutMovement>,
  AxiosError<ErrorMessage>,
  WorkoutMovementWrite
> {
  const queryClient = useQueryClient();

  const createWorkoutMovement = (
    workoutMovement: WorkoutMovementWrite,
  ): Promise<AxiosResponse<WorkoutMovement>> => {
    return client.post('workout-movements/', workoutMovement);
  };

  return useMutation(createWorkoutMovement, {
    onSuccess: () => {
      queryClient.invalidateQueries('workoutMovements');
    },
  });
}
